import axios from 'axios'

export default () => {
  return axios.create({
    baseURL: `http://localhost:8081/`
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js